import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SessionService } from 'src/app/session-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigSettingDto } from 'src/app/model/business/ConfigSettingDto';

@Component({
  selector: 'app-idin-verification-failed-page',
  templateUrl: './idin-verification-failed-page.component.html',
  styleUrls: ['./idin-verification-failed-page.component.css'],
})
export class IdinVerificationFailedPageComponent implements OnInit {
  relativePath: string;

  @Output()
  resetApplication = new EventEmitter();

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    const {
      productType,
      locale,
    } = this.activatedRoute.snapshot.params;

    this.relativePath = locale ?
      `/${locale}/${productType}` :
      `/${productType}`;
  }

  ngOnInit(): void {}

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }

  calculationPage(): void {
    this.resetApplication.emit();
    this.router.navigate([`${this.relativePath}/calculation`, this.sessionService.getIntermediaryId()]);
  }
}
